export default __webpack_public_path__ + "static/hr-8fe1b5a5b263121d704524244a7a41f5.svg";